import { ShieldCheck, ShieldAlert, ShieldX } from 'lucide-react';

// Etiquetas/badges de reportes. Extraído por ENG-LOC-01.
export const STATUS_LABELS: Record<string, string> = {
  active: 'Activo',
  completed: 'Completado',
  expired: 'Vencido',
  cancelled: 'Cancelado',
};

export const DECLARATION_BADGES: Record<
  string,
  { label: string; color: string; icon: typeof ShieldCheck }
> = {
  competent: {
    label: 'Competente',
    color: 'bg-green-100 text-green-700',
    icon: ShieldCheck,
  },
  pending: {
    label: 'Pendiente',
    color: 'bg-amber-100 text-amber-700',
    icon: ShieldAlert,
  },
  none: {
    label: 'Sin declaracion',
    color: 'bg-gray-100 text-gray-600',
    icon: ShieldX,
  },
};
